import React, { memo } from 'react'
import { Link } from 'gatsby'

const tags = [
  { label: 'Discovery & Scoping',  filled: false, left: '0%',   bottom: 60,  rotate: -10 },
  { label: 'iOS Development',      filled: true,  left: '9%',   bottom: 158, rotate: -13 },
  { label: 'Android Development',  filled: false, left: '17%',  bottom: 95,  rotate: -4  },
  { label: 'Cross-Platform UI',    filled: true,  left: '24%',  bottom: 135, rotate: 9   },
  { label: 'Push Notifications',   filled: false, left: '36%',  bottom: 148, rotate: -7  },
  { label: 'Offline Mode',         filled: true,  left: '44%',  bottom: 128, rotate: 11  },
  { label: 'Biometric Auth',       filled: false, left: '51%',  bottom: 88,  rotate: -3  },
  { label: 'In-App Payments',      filled: true,  left: '56%',  bottom: 148, rotate: 7   },
  { label: 'Performance Profiling',filled: false, left: '64%',  bottom: 95,  rotate: -3  },
  { label: 'App Store Launch',     filled: true,  left: '71%',  bottom: 162, rotate: 17  },
  { label: 'Deep Linking',         filled: false, left: '78%',  bottom: 112, rotate: -5  },
  { label: 'OTA Updates',          filled: true,  left: '84%',  bottom: 108, rotate: 8   },
  { label: 'Ongoing Support',      filled: false, left: '91%',  bottom: 58,  rotate: -12 },
]

const marqueeItems = [
  'Flutter', 'React Native', 'Swift', 'Kotlin',
  'Firebase', 'Expo', 'GraphQL', 'Fastlane',
]

const MOB_CtaBanner = () => {
  return (
    <div className="web-cta-banner">
      <div className="cta-content">
        <h2 className="cta-heading">
          Let's Ship Your App <span className="cta-yellow">Faster<br />Than You Think!</span>
        </h2>
        <Link to="/contact">
          <button className="cta-contact-btn">Tell us about your project</button>
        </Link>
      </div>
      <div className="cta-tags-area">
        {tags.map((tag, i) => (
          <span
            key={i}
            className={`cta-tag${tag.filled ? ' cta-tag--filled' : ''}`}
            style={{
              left: tag.left,
              bottom: tag.bottom,
              transform: `rotate(${tag.rotate}deg)`,
            }}
          >
            {tag.label}
          </span>
        ))}
      </div>
      <div className="cta-marquee-strip">
        <div className="cta-marquee-inner">
          {[...marqueeItems, ...marqueeItems, ...marqueeItems].map((item, i) => (
            <span key={i} className="cta-marquee-item">
              {item}&nbsp;&nbsp;<span className="cta-marquee-star">✳</span>&nbsp;&nbsp;
            </span>
          ))}
        </div>
      </div>
    </div>
  )
}

export default memo(MOB_CtaBanner)
